import { render, staticRenderFns } from "./docked-foldout.vue?vue&type=template&id=2d9259f4&scoped=true&"
import script from "./docked-foldout.vue?vue&type=script&lang=ts&"
export * from "./docked-foldout.vue?vue&type=script&lang=ts&"
import style0 from "./docked-foldout.vue?vue&type=style&index=0&id=2d9259f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9259f4",
  null
  
)

export default component.exports